import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import './BXmakerAuthuseremailLink.css';

/**
 * @emits onClick {}
 */
Vue.component('BXmakerAuthuseremailLink',
    {
        methods:{
            onClick(){
                this.$emit('onClick');
            }
        },
        template: `
            <a href="#" class="bxmaker-authuseremail-link"  @click.prevent.stop="onClick">
                 <slot />
            </a>
        `,
    });